import { render } from "./IconButton.vue?vue&type=template&id=80fb6a84&scoped=true"
import script from "./IconButton.vue?vue&type=script&lang=js"
export * from "./IconButton.vue?vue&type=script&lang=js"

import "./IconButton.vue?vue&type=style&index=0&id=80fb6a84&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-80fb6a84"

export default script